import React, { useContext, useEffect, useState } from "react";
import AppLayoutSecondaryHeader from "../../layout/AppLayout/AppLayoutSecondaryHeader";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AddModuleForm from "./addModuleForm";
import {
  _DELETE_MODULE,
  _LIST_MODULES,
  _UPDATE_MODULE,
} from "../../../models/modulesModel";
import { groupByMultiple } from "../../../utils";
import { Spin } from "antd";
import { Form, Table } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDialog } from "../../../context/DialogContext";
import PsContext from "../../../context";
import { PsNoData } from "../../../components";

const ModulesList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const { openDialog } = useDialog();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _LIST_MODULES().then((res) => {
      if (res.status == "1") {
        let d = groupByMultiple(res.data, function (obj) {
          return [obj.module_title];
        });
        setDataList(res.data);
        setDataView(d);
      } else {
        setDataList([]);
        setDataView([]);
      }
      setLoader(false);
    });
  };

  const getInnerRows = (items) => {
    let rv = [];
    items.map((item, i) => {
      rv.push(
        <tr className="fs-12 valign-middle">
          <td></td>
          <td></td>
          <td>
            {item.module_description}
            <br />
            {item.module_name}
          </td>
          <td align="center">
            <Form.Check
              type="checkbox"
              checked={item.action_create == "1" ? true : false}
              onChange={(e) => handleCheckChange(item, e)}
              name="action_create"
            />
          </td>
          <td align="center">
            <Form.Check
              type="checkbox"
              checked={item.action_list == "1" ? true : false}
              onChange={(e) => handleCheckChange(item, e)}
              name="action_list"
            />
          </td>
          <td align="center">
            <Form.Check
              type="checkbox"
              checked={item.action_update == "1" ? true : false}
              onChange={(e) => handleCheckChange(item, e)}
              name="action_update"
            />
          </td>
          <td align="center">
            <Form.Check
              type="checkbox"
              checked={item.action_delete == "1" ? true : false}
              onChange={(e) => handleCheckChange(item, e)}
              name="action_delete"
            />
          </td>
          <td align="center">
            <Form.Check
              type="checkbox"
              checked={item.action_print == "1" ? true : false}
              onChange={(e) => handleCheckChange(item, e)}
              name="action_print"
            />
          </td>
          <td align="center">
            <Form.Check
              type="checkbox"
              checked={item.action_export == "1" ? true : false}
              onChange={(e) => handleCheckChange(item, e)}
              name="action_export"
            />
          </td>
          <td align="center">
            <IconButton
              color="inherit"
              title="Delete Module"
              onClick={() => handleDeleteClick(item)}
            >
              <DeleteIcon />
            </IconButton>
          </td>
        </tr>
      );
    });
    return rv;
  };

  const handleDeleteClick = (item) => {
    openDialog({
      title: "Confirm",
      message: "Do you want to Delete the Module ?",
      onConfirm: () => confirmDelete(item),
    });
  };

  const confirmDelete = (item) => {
    setLoader(true);
    _DELETE_MODULE({ id: item.id, module_name: item.module_name }).then(
      (res) => {
        if (res.status == "1") {
          context.setAlertMsg(res.message || "Deleted");
          loadData();
        } else {
          openDialog({
            title: "Error",
            message: res.message || "Error on Delete",
          });
          setLoader(false);
        }
      }
    );
  };

  const handleCheckChange = (item, e) => {
    openDialog({
      title: "Confirm",
      message: "Do you want to Update ?",
      onConfirm: () => confirmUpdate(item, e),
    });
  };

  const confirmUpdate = (item, e) => {
    setLoader(true);
    _UPDATE_MODULE({
      id: item.id,
      module_name: item.module_name,
      action_name: e.target.name,
      action_value: e.target.checked ? "0" : "1",
    }).then((res) => {
      if (res.status == "1") {
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
        setLoader(false);
      }
    });
  };

  return (
    <>
      <AppLayoutSecondaryHeader title="Modules List" backTo="/app/settings">
        <IconButton
          color="inherit"
          onClick={(e) => setAddModal(true)}
          title="Add Module"
        >
          <AddIcon />
        </IconButton>
        <IconButton color="inherit" onClick={(e) => loadData()} title="Refresh">
          <AutorenewIcon />
        </IconButton>
      </AppLayoutSecondaryHeader>
      <div className="container mt-115">
        <Spin spinning={loader}>
          <div>
            <Table size="sm" hover bordered>
              <thead>
                <tr className="fs-12">
                  <th width="60">S.No</th>
                  <th width="150">Group</th>
                  <th>Module</th>
                  <th width="80" className="text-center">
                    Create
                  </th>
                  <th width="80" className="text-center">
                    List
                  </th>
                  <th width="80" className="text-center">
                    Update
                  </th>
                  <th width="80" className="text-center">
                    Delete
                  </th>
                  <th width="80" className="text-center">
                    Print
                  </th>
                  <th width="80" className="text-center">
                    Export
                  </th>
                  <th width="60" className="text-center">
                    #
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataList.length < 1 && !loader && (
                  <tr>
                    <td colSpan={10}>
                      <PsNoData withHeight />
                    </td>
                  </tr>
                )}
                {dataView.map((items, i) => {
                  return (
                    <>
                      <tr key={i} className="fs-12">
                        <td align="center">{i + 1}</td>
                        <td colSpan={9}>{items[0].module_title}</td>
                      </tr>
                      {getInnerRows(items)}
                    </>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </Spin>
      </div>

      <AddModuleForm
        show={addModal}
        onHide={(e) => setAddModal(false)}
        onSuccess={() => {
          setAddModal(false);
          loadData();
        }}
      />
    </>
  );
};
export default ModulesList;
